<InactivityModal></InactivityModal>

<div class="d-flex flex-column bg-gray">
  <HomeNavBar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></HomeNavBar>

  <div class="container-fluid flex-grow-1">
    <div class="row">
      <div class="col-12 overflow-auto mt-2 mb-5 pb-3">
        <div class="container-fluid px-2 px-sm-3 px-lg-4 pb-4">
          <section class="event-survey-experience card border-0 shadow-sm rounded mb-3 overflow-hidden">
            <div class="card-body p-3">
              <div class="row g-4 align-items-center">
                <div class="col-12">
                  <div class="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill bg-white border text-dark text-xxs fw-bold mb-2">
                    <i class="bi bi-heart-fill text-danger"></i>
                    My Donation Campaigns
                  </div>
                  <h5 class="fw-bold text-dark mb-2">Create and manage your campaigns.</h5>
                  <p class="text-muted mb-2 d-none d-md-block">Update campaign details, publish drafts, and manage campaign progress in one place.</p>

                  <div class="d-flex flex-wrap gap-2 mb-4">
                    <button
                      type="button"
                      class="btn btn-light border rounded px-3"
                      @click="go_to_explore_page()"
                    >
                      <i class="bi bi-compass me-2"></i><span class="d-inline d-sm-none">Explore</span><span class="d-none d-sm-inline">Explore Campaigns</span>
                    </button>
                    <button
                      type="button"
                      class="btn rounded px-3"
                      :class="active_tab === 'manage' ? 'btn-primary' : 'btn-light border'"
                      @click="set_tab('manage')"
                    >
                      <i class="bi bi-kanban me-2"></i>My Campaigns
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div
            v-if="page_loading"
            class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
            role="status"
            aria-live="polite"
          >
            <div class="marketplace-loader-card">
              <div class="marketplace-loader-orbit">
                <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
                <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
                <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
                  <i class="bi bi-kanban fs-2 text-primary"></i>
                </span>
                <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
                <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
              </div>
              <p class="marketplace-loader-title mb-1">Loading your campaigns</p>
              <p class="marketplace-loader-copy mb-0">We are preparing your drafts, details, and campaign tools.</p>
            </div>
          </div>

          <div v-else-if="active_tab === 'create'" class="row g-3">
            <div class="col-12 col-xl-8">
              <section class="card board-task-card border-0 rounded-4 bg-white shadow-sm overflow-hidden">
                <div class="card-body p-4">
                  <div class="d-flex flex-column flex-lg-row align-items-lg-start justify-content-between gap-3 mb-4">
                    <div>
                      <div class="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill bg-light border text-dark text-xxs fw-bold mb-2">
                        <i class="bi bi-pencil-square text-primary"></i>
                        {{ is_editing_campaign ? 'Edit Campaign' : 'Create Campaign' }}
                      </div>
                      <h5 class="fw-bold text-dark mb-2">{{ is_editing_campaign ? 'Update your campaign details.' : 'Build your campaign.' }}</h5>
                      <p class="text-muted text-xxs mb-0">
                        {{ is_editing_campaign ? 'Update your campaign details and save the changes.' : 'Add the story, goal, category, and timeline to save a campaign draft.' }}
                      </p>
                    </div>
                  </div>

                  <div class="row g-3">
                    <div class="col-12">
                      <label for="campaign_title" class="form-label text-xxs fw-500">Campaign title</label>
                      <input id="campaign_title" v-model="campaign_form.title" type="text" class="form-control rounded text-xxs shadow-none" placeholder="Give your campaign a clear title" />
                      <p v-if="errors.title" class="text-danger text-xxs mt-1 mb-0">{{ errors.title }}</p>
                    </div>

                    <div class="col-12">
                      <label for="campaign_story" class="form-label text-xxs fw-500">Campaign story</label>
                      <textarea id="campaign_story" v-model="campaign_form.description" class="form-control rounded text-xxs shadow-none" rows="5" placeholder="Explain why this campaign matters and how the money will be used"></textarea>
                      <p v-if="errors.description" class="text-danger text-xxs mt-1 mb-0">{{ errors.description }}</p>
                    </div>

                    <div class="col-12 col-md-6">
                      <label for="campaign_category" class="form-label text-xxs fw-500">Category</label>
                      <select id="campaign_category" v-model="campaign_form.category_id" class="form-select rounded text-xxs shadow-none">
                        <option value="">Select category</option>
                        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                      </select>
                      <p v-if="errors.category_id" class="text-danger text-xxs mt-1 mb-0">{{ errors.category_id }}</p>
                    </div>

                    <div class="col-12 col-md-6">
                      <label for="campaign_goal_amount" class="form-label text-xxs fw-500">Goal amount</label>
                      <input id="campaign_goal_amount" v-model="campaign_form.goal_amount" type="number" min="0" class="form-control rounded text-xxs shadow-none" placeholder="50000" />
                      <p v-if="errors.goal_amount" class="text-danger text-xxs mt-1 mb-0">{{ errors.goal_amount }}</p>
                    </div>

                    <div class="col-12 col-md-6">
                      <label for="campaign_start_date" class="form-label text-xxs fw-500">Start date</label>
                      <input
                        id="campaign_start_date"
                        v-model="campaign_form.start_date"
                        type="date"
                        class="form-control rounded text-xxs shadow-none"
                        :max="get_campaign_start_date_max()"
                        @change="validate_campaign_date_fields"
                        @input="validate_campaign_date_fields"
                      />
                      <p v-if="errors.start_date" class="text-danger text-xxs mt-1 mb-0">{{ errors.start_date }}</p>
                    </div>

                    <div class="col-12 col-md-6">
                      <label for="campaign_end_date" class="form-label text-xxs fw-500">End date</label>
                      <input
                        id="campaign_end_date"
                        v-model="campaign_form.end_date"
                        type="date"
                        class="form-control rounded text-xxs shadow-none"
                        :min="get_campaign_end_date_min()"
                        @change="validate_campaign_date_fields"
                        @input="validate_campaign_date_fields"
                      />
                      <p v-if="errors.end_date" class="text-danger text-xxs mt-1 mb-0">{{ errors.end_date }}</p>
                    </div>

                    <div class="col-12">
                      <div class="d-flex justify-content-end pt-2">
                        <button type="button" class="btn btn-primary text-xxs rounded shadow-sm px-3 py-2" :disabled="is_saving_campaign || !token_exists" @click="submit_campaign()">
                          {{ is_saving_campaign ? (is_editing_campaign ? 'Updating...' : 'Saving...') : (is_editing_campaign ? 'Update Campaign' : 'Save Draft') }}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </section>

              <section class="card board-task-card border-0 rounded-4 bg-white shadow-sm overflow-hidden mt-3">
                <div class="card-body p-4">
                  <div class="d-flex flex-column flex-sm-row align-items-sm-start justify-content-between gap-3 mb-2">
                    <div>
                      <div class="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill bg-light border text-dark text-xxs fw-bold mb-2">
                        <i class="bi bi-paperclip text-primary"></i>
                        Supporting Files
                      </div>
                      <div class="text-muted text-xxs">Upload documents, pictures, or videos for this campaign.</div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-light border text-xxs rounded"
                      @click="$refs.campaign_documents_input?.click()"
                    >
                      <i class="bi bi-paperclip me-2"></i>Select Files
                    </button>
                  </div>

                  <div v-if="combined_campaign_supporting_files.length" class="row g-2 mt-1">
                    <div
                      v-for="(entry, index) in combined_campaign_supporting_files"
                      :key="entry.id"
                      class="col-6 col-lg-3"
                    >
                      <div class="position-relative h-100">
                        <button
                          v-if="entry.source === 'pending'"
                          type="button"
                          class="card board-task-card border rounded-5 bg-light shadow-sm h-100 w-100 text-start"
                          @click="open_local_file_preview(entry.file)"
                          >
                          <div class="ratio ratio-16x9 border-bottom rounded-top overflow-hidden bg-white">
                            <img
                              v-if="String(entry.file.type || '').startsWith('image/')"
                              :src="get_local_file_preview_url(entry.file)"
                              :alt="entry.file.name"
                              class="event-view-sidebar-cover-image"
                            />
                            <video
                              v-else-if="String(entry.file.type || '').startsWith('video/')"
                              :src="get_local_file_preview_url(entry.file)"
                              class="event-view-sidebar-cover-image"
                              muted
                            ></video>
                            <div v-else class="d-flex align-items-center justify-content-center h-100">
                              <i :class="['bi', get_campaign_file_icon_class({ name: entry.file.name, file_url: entry.file.name }), 'display-4']"></i>
                            </div>
                          </div>
                          <div class="card-body p-3">
                            <div class="fw-semibold text-dark text-xs mb-1" :title="entry.file.name">
                              {{
                                entry.file.name.length > 24
                                  ? `${entry.file.name.slice(0, 21)}...`
                                  : entry.file.name
                              }}
                            </div>
                            <div class="text-primary text-xxs">Pending upload</div>
                          </div>
                        </button>

                        <button
                          v-else
                          type="button"
                        class="card board-task-card border rounded-5 bg-light shadow-sm h-100 w-100 text-start"
                          @click="open_existing_file_preview(entry.file)"
                        >
                          <div class="ratio ratio-16x9 border-bottom rounded-top overflow-hidden bg-white">
                            <img
                              v-if="is_campaign_image_file(entry.file)"
                              :src="get_campaign_file_url(entry.file)"
                              :alt="get_campaign_file_name(entry.file, index)"
                              class="event-view-sidebar-cover-image"
                            />
                            <video
                              v-else-if="is_campaign_video_file(entry.file)"
                              :src="get_campaign_file_url(entry.file)"
                              class="event-view-sidebar-cover-image"
                              muted
                            ></video>
                            <div v-else class="d-flex align-items-center justify-content-center h-100">
                              <i :class="['bi', get_campaign_file_icon_class(entry.file), 'display-4']"></i>
                            </div>
                          </div>
                          <div class="card-body p-3">
                            <div class="fw-semibold text-dark text-xs mb-1" :title="get_campaign_file_name(entry.file, index)">
                              {{
                                get_campaign_file_name(entry.file, index).length > 24
                                  ? `${get_campaign_file_name(entry.file, index).slice(0, 21)}...`
                                  : get_campaign_file_name(entry.file, index)
                              }}
                            </div>
                            <div class="text-muted text-xxs">{{ format_datetime(get_campaign_file_created_at(entry.file)) || 'Uploaded' }}</div>
                          </div>
                        </button>

                        <button
                          v-if="entry.source === 'pending'"
                          type="button"
                          class="btn btn-sm btn-danger position-absolute top-0 end-0 m-2 rounded-circle d-flex align-items-center justify-content-center p-1"
                          @click.stop="remove_pending_campaign_document(campaign_document_files.findIndex((file) => file === entry.file))"
                        >
                          <i class="bi bi-x"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-else class="text-muted text-xxs mt-2">No supporting files selected.</div>

                  <div class="d-flex justify-content-end gap-2 mt-3">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary text-xxs rounded px-3 py-2"
                      :disabled="is_uploading_supporting_files || !campaign_document_files.length"
                      @click="upload_campaign_supporting_files"
                    >
                      <i class="bi bi-cloud-upload me-2"></i>
                      {{
                        is_uploading_supporting_files
                          ? 'Uploading...'
                          : 'Upload Files'
                      }}
                    </button>
                  </div>
                </div>
              </section>
            </div>

            <div class="col-12 col-xl-4">
              <section class="card board-task-card border-0 rounded-4 bg-white shadow-sm overflow-hidden">
                <input
                  ref="campaign_cover_input"
                  type="file"
                  class="d-none"
                  accept="image/*"
                  @change="handle_campaign_cover_change"
                />
                <input
                  ref="campaign_documents_input"
                  type="file"
                  class="d-none"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip,.rar,image/*,video/*"
                  multiple
                  @change="handle_campaign_document_change"
                />
                <div class="card-body p-3 p-lg-4">
                  <div class="d-flex flex-column flex-sm-row align-items-sm-start justify-content-between gap-3 mb-3">
                    <div class="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill bg-light border text-dark text-xxs fw-bold align-self-start">
                      <i class="bi bi-eye text-primary"></i>
                      Preview
                    </div>
                  </div>

                  <div
                    v-if="preview_campaign.cover_image"
                    class="event-view-sidebar-cover rounded overflow-hidden cursor-pointer mb-3"
                    @click="trigger_campaign_cover_upload"
                  >
                    <img
                      :src="preview_campaign.cover_image"
                      :alt="preview_campaign.title"
                      class="event-view-sidebar-cover-image"
                    />
                  </div>
                  <div
                    v-else
                    class="event-view-sidebar-cover rounded overflow-hidden bg-light d-flex flex-column align-items-center justify-content-center text-muted text-center p-4 cursor-pointer mb-3"
                    @click="trigger_campaign_cover_upload"
                  >
                    <i class="bi bi-image fs-2 mb-2"></i>
                    <span class="text-xxs fw-500">{{ is_uploading_campaign_image ? 'Uploading image...' : 'Click to upload campaign image' }}</span>
                  </div>

                  <p v-if="errors.cover_image" class="text-danger text-xxs mt-1 mb-2">{{ errors.cover_image }}</p>
                  <div class="d-flex gap-2 mb-3">
                    <button
                      type="button"
                      class="btn btn-sm btn-light border text-xxs rounded"
                      :disabled="is_uploading_campaign_image"
                      @click="trigger_campaign_cover_upload"
                    >
                      {{ preview_campaign.cover_image ? 'Change Image' : 'Select Image' }}
                    </button>
                    <button
                      v-if="is_editing_campaign"
                      type="button"
                      class="btn btn-sm btn-primary text-xxs rounded"
                      :disabled="is_uploading_campaign_image || !campaign_form.cover_image"
                      @click="upload_campaign_cover"
                    >
                      {{ is_uploading_campaign_image ? 'Uploading...' : 'Upload Image' }}
                    </button>
                  </div>

                  <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
                    <span class="marketplace-card-pill my-events-pill my-events-pill--published">{{ preview_campaign.category }}</span>
                    <span class="task-chip task-chip-status text-capitalize">
                      {{ preview_campaign.status }}
                    </span>
                  </div>

                  <h5 class="fw-bold text-dark mb-2">{{ preview_campaign.title }}</h5>
                  <p class="text-muted mb-3">{{ get_campaign_summary(preview_campaign.description) }}</p>

                  <div class="row g-3 mb-3">
                    <div class="col-12 col-sm-6">
                      <div class="border rounded bg-light h-100 p-3">
                        <div class="text-dark text-uppercase text-xxs fw-bold mb-1">Goal</div>
                        <div class="text-muted text-xxs">{{ format_currency(preview_campaign.goal_amount) }}</div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="border rounded bg-light h-100 p-3">
                        <div class="text-dark text-uppercase text-xxs fw-bold mb-1">Ends</div>
                        <div class="text-muted text-xxs">{{ format_date(preview_campaign.end_date) }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="progress mb-3">
                    <div class="progress-bar bg-danger" role="progressbar" :style="{ width: `${get_progress(preview_campaign)}%` }"></div>
                  </div>

                  <div class="text-muted text-xxs">New campaigns are created as drafts first.</div>

                  <div v-if="is_editing_campaign && editing_campaign" class="d-flex flex-wrap gap-2 pt-3 mt-3 border-top">
                    <button
                      type="button"
                      class="btn btn-light border fw-semibold rounded shadow-sm px-3 py-2 text-xxs"
                      @click="back_to_manage_campaigns"
                    >
                      <i class="bi bi-arrow-left me-2"></i>Back
                    </button>
                    <button
                      v-if="editing_campaign.status !== 'active'"
                      type="button"
                      class="btn btn-primary fw-semibold rounded shadow-sm px-3 py-2 text-xxs"
                      :disabled="is_toggling_campaign_id === editing_campaign.id"
                      @click="toggle_campaign_status(editing_campaign)"
                    >
                      <i class="bi bi-send-check me-2"></i>{{ is_toggling_campaign_id === editing_campaign.id ? 'Saving...' : 'Publish' }}
                    </button>
                    <button
                      v-if="editing_campaign.status === 'active'"
                      type="button"
                      class="btn btn-primary fw-semibold rounded shadow-sm px-3 py-2 text-xxs"
                      :disabled="is_toggling_campaign_id === editing_campaign.id"
                      @click="toggle_campaign_status(editing_campaign)"
                    >
                      <i class="bi bi-pause-circle me-2"></i>{{ is_toggling_campaign_id === editing_campaign.id ? 'Saving...' : 'Pause' }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger fw-semibold rounded shadow-sm px-3 py-2 text-xxs"
                      :disabled="is_deleting_campaign_id === editing_campaign.id"
                      @click="delete_campaign(editing_campaign)"
                    >
                      <i class="bi bi-trash3 me-2"></i>{{ is_deleting_campaign_id === editing_campaign.id ? 'Deleting...' : 'Delete' }}
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div v-else class="row g-3">
            <div class="col-12">
              <div v-if="!token_exists" class="alert alert-warning text-xxs mb-3">
                Sign in to view and create your campaigns.
              </div>
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div class="min-w-0">
                  <h5 class="fw-bold text-dark mb-2">Manage My Campaigns</h5>
                </div>

                <div class="d-flex flex-column gap-2 flex-grow-1">
                  <div class="d-flex d-md-none flex-column gap-2 w-100">
                    <div>
                      <div class="input-group input-group-sm rounded">
                        <span class="input-group-text bg-white border-end-0 rounded-start text-xxs">
                          <i class="bi bi-search text-muted"></i>
                        </span>
                        <input
                          v-model="search_query"
                          type="text"
                          class="form-control border-start-0 rounded-end shadow-none text-xxs"
                          placeholder="Search campaigns..."
                        />
                      </div>
                    </div>
                    <div>
                      <div class="text-muted small fw-semibold mb-1">Filter</div>
                      <select v-model="manage_filter" class="form-select form-select-sm w-100 rounded shadow-none text-xxs py-2">
                        <option value="all">All</option>
                        <option value="draft">Drafts</option>
                        <option value="active">Active</option>
                        <option value="paused">Paused</option>
                        <option value="completed">Completed</option>
                      </select>
                    </div>
                  </div>

                  <div class="d-none d-md-flex align-items-center justify-content-end gap-2 flex-nowrap w-100">
                    <div class="input-group input-group-sm task-filter-search flex-shrink-0 w-25">
                      <span class="input-group-text bg-white border-end-0 rounded-start">
                        <i class="bi bi-search text-muted"></i>
                      </span>
                      <input
                        v-model="search_query"
                        type="text"
                        class="form-control border-start-0 rounded-end shadow-none text-xxs"
                        placeholder="Search campaigns..."
                      />
                    </div>

                    <div class="dropdown">
                      <button
                        class="btn btn-light board-icon-btn d-inline-flex align-items-center justify-content-center position-relative"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        title="Filter campaigns"
                      >
                        <i class="bi bi-funnel-fill"></i>
                        <span
                          v-if="manage_filter !== 'all'"
                          class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"
                        >
                          1
                        </span>
                      </button>

                      <div class="dropdown-menu dropdown-menu-end task-filter-dropdown shadow rounded-3 mt-2 p-0">
                        <div class="task-filter-header">
                          <div>
                            <p class="fw-bold text-dark text-sm mb-0">Filter Campaigns</p>
                            <span class="text-muted text-xxs">Narrow your campaign list by status.</span>
                          </div>
                          <div class="d-flex gap-2 align-items-center flex-shrink-0">
                            <button
                              v-if="manage_filter !== 'all'"
                              type="button"
                              class="btn btn-link btn-sm text-danger p-0 text-xs fw-semibold"
                              @click="manage_filter = 'all'"
                            >
                              Clear all
                            </button>
                          </div>
                        </div>

                        <div class="task-filter-body">
                          <div class="task-filter-section">
                            <label class="task-filter-label">Status</label>
                            <div class="task-filter-chip-list d-flex flex-column gap-2">
                              <button type="button" class="task-filter-chip d-flex align-items-center justify-content-between" :class="manage_filter === 'all' ? 'status-active' : 'status-inactive'" @click="manage_filter = 'all'">
                                <span>All</span>
                                <span class="opacity-75">{{ get_manage_filter_count('all') }}</span>
                              </button>
                              <button type="button" class="task-filter-chip d-flex align-items-center justify-content-between" :class="manage_filter === 'draft' ? 'status-active' : 'status-inactive'" @click="manage_filter = 'draft'">
                                <span>Drafts</span>
                                <span class="opacity-75">{{ get_manage_filter_count('draft') }}</span>
                              </button>
                              <button type="button" class="task-filter-chip d-flex align-items-center justify-content-between" :class="manage_filter === 'active' ? 'status-active' : 'status-inactive'" @click="manage_filter = 'active'">
                                <span>Active</span>
                                <span class="opacity-75">{{ get_manage_filter_count('active') }}</span>
                              </button>
                              <button type="button" class="task-filter-chip d-flex align-items-center justify-content-between" :class="manage_filter === 'paused' ? 'status-active' : 'status-inactive'" @click="manage_filter = 'paused'">
                                <span>Paused</span>
                                <span class="opacity-75">{{ get_manage_filter_count('paused') }}</span>
                              </button>
                              <button type="button" class="task-filter-chip d-flex align-items-center justify-content-between" :class="manage_filter === 'completed' ? 'status-active' : 'status-inactive'" @click="manage_filter = 'completed'">
                                <span>Completed</span>
                                <span class="opacity-75">{{ get_manage_filter_count('completed') }}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-4">
                <button type="button" class="btn btn-sm btn-primary text-xxs rounded px-3 py-1" @click="set_tab('create')">
                  Add Campaign
                </button>
              </div>

              <div class="row g-3">
                <div v-if="my_campaigns.length" class="col-12">
                  <div class="row g-3 align-items-start">
                    <div
                      v-for="campaign in my_campaigns"
                      :key="campaign.id"
                      class="col-12 col-sm-6 col-lg-4 col-xl-3"
                    >
                      <div class="marketplace-product-card d-flex flex-column overflow-hidden">
                        <div class="position-relative marketplace-card-media cursor-pointer" @click="open_campaign_detail(campaign)">
                          <div class="event-view-sidebar-cover rounded overflow-hidden bg-light">
                            <img
                              v-if="get_campaign_cover_image(campaign)"
                              :src="get_campaign_cover_image(campaign)"
                              :alt="campaign?.name || 'Untitled campaign'"
                              class="event-view-sidebar-cover-image"
                            />
                            <div v-else class="w-100 h-100 bg-light d-flex flex-column align-items-center justify-content-center text-muted text-center p-3">
                              <i class="bi bi-image fs-4 mb-2"></i>
                              <span class="text-xxs fw-500">No campaign image</span>
                            </div>
                          </div>
                          <div class="position-absolute top-0 start-0 mt-4 ms-2 d-flex gap-2 flex-wrap">
                            <span class="marketplace-card-pill my-events-pill my-events-pill--published">
                              {{ campaign?.category?.name || campaign?.category || "Uncategorized" }}
                            </span>
                          </div>
                          <span v-if="campaign.end_date" class="position-absolute top-0 end-0 mt-4 me-2 task-chip task-chip-priority">
                            {{ calculate_days_left(campaign.end_date) }} days left
                          </span>
                        </div>
                        <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
                          <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                            <span class="task-chip task-chip-status text-capitalize ms-auto">
                              {{ campaign.status }}
                            </span>
                          </div>

                          <div class="cursor-pointer" @click="open_campaign_detail(campaign)">
                            <p class="marketplace-card-name mb-1">{{ campaign?.name || "Untitled campaign" }}</p>
                            <div class="text-xs text-muted mb-1">{{ get_campaign_summary(campaign.description || "") }}</div>
                            <div class="text-xs text-muted mb-0">
                              {{ format_date(campaign.start_date) }} - {{ format_date(campaign.end_date) }}
                            </div>
                          </div>

                          <div class="mt-3">
                            <div class="d-flex justify-content-between align-items-center gap-2 mb-1">
                              <div class="fw-bold text-dark text-xs">{{ format_currency(campaign.current_amount) }}</div>
                              <div class="text-muted text-xxs">Goal {{ format_currency(campaign.goal_amount) }}</div>
                            </div>
                            <div class="progress mb-1">
                              <div
                                class="progress-bar bg-danger"
                                role="progressbar"
                                :style="{ width: `${get_progress(campaign)}%` }"
                                :aria-valuenow="get_progress(campaign)"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <div class="text-muted text-xxs">{{ get_progress(campaign) }}% funded</div>
                          </div>

                          <div class="mt-3">
                            <button
                              type="button"
                              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                              @click="start_edit_campaign(campaign)"
                            >
                              Manage
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!my_campaigns.length" class="col-12">
                  <div class="text-center py-5">
                    <i class="bi bi-megaphone text-muted display-6"></i>
                    <h6 class="fw-bold text-dark mt-3 mb-1">No campaigns in this view</h6>
                    <p class="text-muted small mb-3">Switch the filter or create a new campaign draft.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<teleport to="body">
  <div class="modal fade" id="campaign_supporting_file_preview_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 rounded-4 shadow-sm overflow-hidden">
        <div class="modal-header border-0 shadow-sm">
          <h5 class="modal-title text-xs mb-0 text-truncate">{{ preview_file?.name || 'File preview' }}</h5>
          <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close" @click="clear_file_preview"></button>
        </div>
        <div class="modal-body p-3 p-lg-4">
          <div v-if="preview_file?.is_image" class="text-center">
            <img :src="preview_file.url" :alt="preview_file.name" class="img-fluid rounded" />
          </div>
          <div v-else-if="preview_file?.is_video">
            <video :src="preview_file.url" controls class="w-100 rounded"></video>
          </div>
          <div v-else-if="preview_file?.is_pdf" class="ratio ratio-16x9">
            <iframe :src="preview_file.url" title="File preview" class="rounded border"></iframe>
          </div>
          <div v-else class="text-center py-4">
            <i class="bi bi-file-earmark-text text-primary display-4"></i>
            <div class="fw-semibold text-dark mt-3 mb-1">{{ preview_file?.name }}</div>
            <div class="text-muted text-xxs mb-3">Preview is not available for this file type.</div>
            <a v-if="preview_file?.url" :href="preview_file.url" target="_blank" rel="noopener noreferrer" class="btn btn-primary btn-sm rounded px-3">
              Open File
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
